<mat-toolbar color="primary" class="principal">
  <mat-toolbar-row fxLayout="row">
    <button class="hamburguer" mat-button title="Menú" (click)="sidenav.toggle()">
      <mat-icon aria-label="Menú">menu</mat-icon>
    </button>
    <a routerLink="/" mat-button>Herramienta de digitación de edictos</a>
    <!-- <div *ngIf="user">
      <button mat-button [matMenuTriggerFor]="menu">Acciones</button>
      <mat-menu #menu="matMenu">
        <a *ngFor="let action of user.routes" routerLink="{{action.url}}" mat-menu-item>{{action.routeName}}</a>
      </mat-menu>
    </div> -->
    <div fxFlex></div>
    <div *ngIf="userService.user" fxLayout="row" fxLayoutAlign="center center">
      <button mat-button [matMenuTriggerFor]="closeMenu">
        <img class="image-button" [src]="userService.user.imageSrc" [alt]="userService.user.email"> {{userService.user.name}}
      </button>
      <mat-menu fxFlex #closeMenu="matMenu">
        <a (click)="userService.logout()" fxFlex mat-menu-item>Cerrar Sesión</a>
      </mat-menu>
    </div>
  </mat-toolbar-row>
</mat-toolbar>
<mat-sidenav-container class="principal">
  <mat-sidenav mode="side" #sidenav>
    <div fxLayout="column" class="side-buttons" *ngIf="userService.user">
      <a mat-button *ngFor="let action of userService.menuRoutes" routerLinkActive="active mat-primary" routerLink="{{action.url}}">{{action.routeName | uppercase}}</a>
    </div>
  </mat-sidenav>
  <mat-sidenav-content>
    <section class="sidenav-content">
      <app-edition-statistics></app-edition-statistics>
      <div [@fadeInAnimation]="getRouteAnimation(route)">
        <router-outlet #route="outlet"></router-outlet>
      </div>
    </section>
  </mat-sidenav-content>
</mat-sidenav-container>
